<template>
    <div>
        <ul class="nav nav-tabs">
            <li
                v-for="tab in tabs"
                :key="tab.id"
                :class="{ active: isActiveTab(tab) }"
                @click.prevent="setActiveTab(tab)"
            >
                <a href="#">{{ tab.name }}</a>
            </li>
        </ul>
        <div v-if="keepAlive" class="tab-content">
            <template v-for="tab in tabs">
                <div v-show="isActiveTab(tab)" :key="tab.id">
                    <slot :name="'tab-content-' + tab.id"></slot>
                </div>
            </template>
        </div>
        <div v-else class="tab-content">
            <slot v-if="activeTabId" :name="tabContentSlotName"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabNavigation',

    props: {
        tabs: {
            type: Array,
            required: true,
            validator(items) {
                const hasRequiredFields = item => {
                    return item.hasOwnProperty('id') && item.hasOwnProperty('name');
                };
                return items.every(hasRequiredFields);
            }
        },
        initialSelectedTabId: {
            type: String,
            required: false,
            default: () => null
        },
        keepAlive: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            activeTabId: this.initialSelectedTabId ? this.initialSelectedTabId : this.getFirstTabId(this.tabs)
        };
    },

    watch: {
        tabs(newValue) {
            if (newValue && newValue.length > 0) {
                const tabIds = newValue.map(v => v.id);
                const isValidTabId = tabIds.includes(this.activeTabId);
                if (!isValidTabId) {
                    this.activeTabId = this.getFirstTabId(newValue);
                }
            }
        }
    },

    computed: {
        tabContentSlotName() {
            return `tab-content-${this.activeTabId}`;
        }
    },

    methods: {
        setActiveTab(tab) {
            this.activeTabId = tab.id;
            this.$emit('change', tab.id);
        },
        isActiveTab(tab) {
            return tab.id === this.activeTabId;
        },
        getFirstTabId(tabs) {
            return tabs && tabs[0] && tabs[0].id;
        }
    }
};
</script>

<style lang="scss">
@import '../assets/styles/settings';

.tabsNav {
    border-bottom: 1px solid $color_bootstrap_table_border;

    .btn {
        border-radius: 0;
        border-top: 0;
        border-bottom: 0;
        font-weight: bold;

        .fa {
            margin-right: 2px;
        }
    }
}

.tabContent {
    overflow-y: auto;
    max-height: calc(100vh - 150px);
}
</style>
